import React, { Component } from "react";

import ReactCrop, {
  centerCrop,
  makeAspectCrop,
  convertToPixelCrop,
} from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

import Header from "../component/Header";
import Breadcrumb from "../component/Breadcumb";
import Footer from "../component/Footer";
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { BASEURL } from "../../Global";
import { Col, Modal, ModalBody, Row } from "reactstrap";
import { FaCheckCircle } from "react-icons/fa";
import { IoMdCloseCircle } from "react-icons/io";
import { Box, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";

class OldStudents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageSrc: null,
      selectedImage: null,
      crop: undefined,
      scale: 1,
      rotate: 0,
      aspect: 1,
      schoolList: [],
      branchList: [],
      classList: [],
      isModal: false,
      isAltId: false,
      userData: {},
      paymentType: 'Offline',
      getByID: {}
    };
    this.imgRef = React.createRef();
  }

  componentDidMount() {
    document.title = "Old Students Registration - My Jainism";
  }

  onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      this.setState({ crop: undefined });
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        this.setState({ imgSrc: reader.result.toString() });
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  onImageLoad = (e) => {
    const { aspect } = this.state;
    if (aspect) {
      const { width, height } = e.currentTarget;
      const crop = centerCrop(
        makeAspectCrop(
          {
            unit: '%',
            width: 90,
          },
          aspect,
          width,
          height
        ),
        width,
        height
      );
      this.setState({ crop });
    }
  };


  onDownloadCropClick = async (completedCrop) => {
    const { imgSrc, } = this.state;
    const image = this.imgRef.current;

    this.setState({ completedCrop: completedCrop })

    if (!image || !completedCrop) {
      throw new Error('Crop canvas does not exist');
    }

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    const offscreen = new OffscreenCanvas(completedCrop.width * scaleX, completedCrop.height * scaleY);
    const ctx = offscreen.getContext('2d');

    if (!ctx) {
      throw new Error('No 2d context');
    }

    ctx.drawImage(
      image,
      completedCrop.x * scaleX,
      completedCrop.y * scaleY,
      completedCrop.width * scaleX,
      completedCrop.height * scaleY,
      0,
      0,
      completedCrop.width * scaleX,
      completedCrop.height * scaleY
    );

    const blob = await offscreen.convertToBlob({
      type: 'image/png',
    });

    const reader = new FileReader();
    reader.onload = () => {
      const base64ImageData = reader.result;
      this.setState({ selectedImage: base64ImageData })
      // console.log('Cropped image base64:', base64ImageData);
    };

    reader.readAsDataURL(blob);
  };

  componentDidMount() {
    this.fetchBranchName()
    this.fetchSchoolName()
  }

  createNewRegistration = async (data) => {
    await fetch(`${BASEURL}/createtenantuserinquiry`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
      })
      .then((response) => {
        if (response.status === 200) {
          response.json().then((responseJson) => {
            if (responseJson) {
              if (responseJson.type === "Error") {
                // this.setState({ isLoading: false })
              } else {
                // toastr.success("Data Added Successfully !!")
                this.setState({
                  isModal: false,
                })
                this.props.navigate(process.env.PUBLIC_URL + "/")
              }
              // console.log("Slider Created")
            }
          });
        } else {
          console.log("");
        }
      })
      .catch((error) => {
        console.log("Fetch Error", error);
      });
  }

  async fetchSchoolName() {
    try {
      await fetch(`${BASEURL}/getalltenantuserswithoutauth`, {
        method: "GET",
        headers: {
          Accept: 'application/json',
        }
      })
        .then(response => {
          if (response.status === 200) {
            response.json().then(responseJson => {
              if (responseJson.data) {
                this.setState({ schoolList: responseJson.data })
              } else {
                // console.log("Data Not Found !!")
              }
            })
          } else {
            // console.log("Something Went Wrong !!")
          }
        })
        .catch((error) => console.error(error));
    } catch (e) {
      console.log("ERROR", e)
    }
  }
  async fetchBranchName() {
    try {
      await fetch(`${BASEURL}/branchwithoutauth`, {
        method: "GET",
        headers: {
          Accept: 'application/json',
        }
      })
        .then(response => {
          if (response.status === 200) {
            response.json().then(responseJson => {
              if (responseJson.data) {
                this.setState({ branchList: responseJson.data })
              } else {
                // console.log("Data Not Found !!")
              }
            })
          } else {
            // console.log("Something Went Wrong !!")
          }
        })
        .catch((error) => console.error(error));
    } catch (e) {
      console.log("ERROR", e)
    }
  }

  async fetchClassName(id) {
        try {
            await fetch(`${BASEURL}/getallclassbytenantwithoutauth/${id}`, {
                method: "GET",
                headers: {
                    Accept: 'application/json',
                }
            })
                .then(response => {
                    if (response.status === 200) {
                        response.json().then(responseJson => {
                            if (responseJson.data) {
                                this.setState({ classList: responseJson.data })
                            } else {
                                // console.log("Data Not Found !!")
                            }
                        })
                    } else {
                        // console.log("Something Went Wrong !!")
                    }
                })
                .catch((error) => console.error(error));
        } catch (e) {
            console.log("ERROR", e)
        }
    }

   convertImageToBase64 = async (imageUrl) => {
  const response = await fetch(imageUrl);
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

getUserById = async (id, setFieldValue) => {
  await fetch(`${BASEURL}/userbyalternateid`,
    {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        "alternate_id": id
      })
    })
    .then((response) => {
      if (response.status === 200) {
        response.json().then(async (responseJson) => {
          if (responseJson.result === true) {
            if (responseJson.data.profile_image) {
              const base64Image = await  this.convertImageToBase64(responseJson.data.profile_image);
              this.setState({ selectedImage: base64Image,  });
            }
            // this.setState({ selectedImage: responseJson.data.profile_image, getByID: responseJson.data })
            // Update Formik state with the API response
            this.fetchClassName(responseJson.data.tenant_id)
            setFieldValue('first_name', responseJson.data.first_name || '');
            setFieldValue('student_id_encode', responseJson.data.id || '');
            setFieldValue('last_name', responseJson.data.last_name || '');
            // setFieldValue('class_id_encode', responseJson.data.student_class || '');
            setFieldValue('dob', responseJson.data.dob || '');
            setFieldValue('gender', responseJson.data.gender || '');
            setFieldValue('blood_group', responseJson.data.blood_group || '');
            setFieldValue('tenant_id_encode', responseJson.data.tenant_id || '');
            // setFieldValue('education', responseJson.data.education || '');
            // setFieldValue('education_dharmik', userData.education_dharmik || '');
            // setFieldValue('student_hobby', userData.student_hobby || '');
            // setFieldValue('father_name', userData.father_name || '');
            // setFieldValue('father_qualification', userData.father_qualification || '');
            // setFieldValue('father_occupation', userData.father_occupation || '');
            // setFieldValue('mother_name', userData.mother_name || '');
            // setFieldValue('mother_qualification', userData.mother_qualification || '');
            setFieldValue('address', responseJson.data.address || '');
            setFieldValue('city', responseJson.data.city || '');
            setFieldValue('email', responseJson.data.user_email || '');
            setFieldValue('whatsapp_no', responseJson.data.mobile || '');
            // setFieldValue('native_place', userData.native_place || '');
            // if (responseJson.type === "Error") {
            //     // this.setState({ isLoading: false })
            // } else {
            //     this.setState({
            //         isModal: false,
            //     })
            //     // toastr.success("Data Added Successfully !!")
            // }
            // console.log("Slider Created")
          } else {
            this.setState({ isAltId: true })
            console.log('erroe==========')
          }
        });
      } else {
        // toastr.error("Something Went Wrong !!")

      }
    })
    .catch((error) => {
      console.log("Fetch Error", error);
    });
}
render() {
  const { imgSrc, crop, scale, rotate, aspect, branchList, schoolList, classList } = this.state;
  return (
    <React.Fragment>
      <Header />
      <Breadcrumb title={"Old Student Registration"} />
      <section class="project-section bg-smoke space-top space-extra-bottom">
        <div class="container my-5">
          <div class="row justify-content-center">
            <div class="contact-form">
              <div class="contact-title mb-45">
                <h2>Admission Form <span>2024-2025</span></h2>
                {/* <p>Lorem ipsum dolor sit amet, consectetur adipis do eiusmod tempor indunt ut labore et dolore magna aliqua.</p> */}
              </div>
            </div>
            <div class="col-lg-9 w-100">
             

              <Formik
                initialValues={{
                  alternate_id: '',
                  first_name: '',
                  last_name: '',
                  class_id_encode: '',
                  branch_id_encode: '',
                  dob: '',
                  gender: '',
                  blood_group: '',
                  tenant_id_encode: '',
                  education: '',
                  education_dharmik: '',
                  student_hobby: '',
                  father_name: '',
                  father_qualification: '',
                  father_occupation: '',
                  mother_name: '',
                  mother_qualification: '',
                  address: '',
                  city: '',
                  email: '',
                  whatsapp_no: '',
                  native_place: '',
                  declaration: false,
                  student_id:''
                }}
                validationSchema={Yup.object({
                  alternate_id: Yup.string().required('Alternate id is required'),
                  first_name: Yup.string().required('First Name is required'),
                  last_name: Yup.string().required('Last Name is required'),
                  class_id_encode: Yup.string().required('Student Class is required'),
                  branch_id_encode: Yup.string(),
                  dob: Yup.date().required('DOB is required'),
                  gender: Yup.string().required('Gender is required'),
                  blood_group: Yup.string(),
                  tenant_id_encode: Yup.string().required('School Name is required'),
                  education: Yup.string(),
                  education_dharmik: Yup.string(),
                  student_hobby: Yup.string(),
                  father_name: Yup.string(),
                  father_qualification: Yup.string(),
                  father_occupation: Yup.string(),
                  mother_name: Yup.string(),
                  mother_qualification: Yup.string(),
                  address: Yup.string().required('Address is required'),
                  city: Yup.string().required('City is required'),
                  email: Yup.string().email('Invalid email format').required('Email is required'),
                  whatsapp_no: Yup.string()
                    .matches(/^\d+$/, 'whatsapp number must contain only digits')
                    .test('is-positive', 'whatsapp number must be a positive number', (value) => {
                      return Number(value) > 0;
                    })
                    .length(10, 'whatsapp number must be exactly 10 digits')
                    .required('whatsapp number is required'),
                  native_place: Yup.string(),
                  declaration: Yup.bool().oneOf([true], 'Declaration is required'),
                })}

                onSubmit={(values) => {
                  const data = { ...values, profile_image_encode: this.state.selectedImage, inquiry_form: "Old" }
                  this.setState({ userData: data, isModal: true })
                  // this.createNewRegistration(data)
                }}
              >
                {({ setFieldValue, handleSubmit, handleChange, values }) => (
                  <Form onSubmit={handleSubmit}>
                    <div className="row g-3">
                      <div class="col-md-3">
                        <label class="lable"> Photo (*) </label>
                        <div className="row" style={{ justifyContent: 'space-around' }}>
                          {/* <div class="inquiry-photo" >
                            {!!imgSrc && (
                              <ReactCrop
                                style={{ width: "'auto'", height: 'auto' }}
                                crop={crop}
                                onChange={(_, percentCrop) => this.setState({ crop: percentCrop })}
                                onComplete={(c) => this.onDownloadCropClick(c)}
                                aspect={aspect}
                              >
                                <img
                                  ref={this.imgRef}
                                  alt="Crop me"
                                  src={imgSrc}
                                  style={{ transform: `scale(${scale}) rotate(${rotate}deg)` }}
                                  onLoad={this.onImageLoad}
                                />
                              </ReactCrop>
                            )}
                          </div> */}
                          <div class="inquiry-photo" >
                            <img src={this.state.selectedImage} />
                          </div>
                        </div>
                        {/* <input type="file" name="image" id="image" onchange="loadFile(event)" class="form-control mt-2" accept="image/*" style={{ width: 'auto', alignContent: 'center' }} onChange={this.onSelectFile} /> */}
                      </div>


                      <div className="col-md-9">
                        <label htmlFor="alternate_id" className="form-label">Alternate Id(*)</label>
                        <Field type="text" className="form-control" id="alternate_id" name="alternate_id" onBlur={(e) => this.getUserById(e.target.value, setFieldValue)} />
                        <ErrorMessage name="alternate_id" component="div" className="text-danger" />

                        <label htmlFor="first_name" className="form-label mt-2">First Name(*)</label>
                        <Field type="text" disabled value={values.first_name} className="form-control" id="first_name" name="first_name" />
                        <ErrorMessage name="first_name" component="div" className="text-danger" />

                        <label htmlFor="last_name" className="form-label mt-2">Last Name(*)</label>
                        <Field type="text" disabled className="form-control" id="last_name" name="last_name" />
                        <ErrorMessage name="last_name" component="div" className="text-danger" />
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="tenant_id_encode" className="form-label">School Name(*)</label>
                        <Field as="select" disabled name="tenant_id_encode" className="select-menu form-control">
                          <option value="">Select School</option>
                          {
                            schoolList?.map((data, ind) => (
                              <option value={data.id} key={ind}>{data?.school_name}</option>
                            ))
                          }
                        </Field>
                        <ErrorMessage name="tenant_id_encode" component="div" className="text-danger" />
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="class_id_encode" className="form-label">Student Class(*)</label>
                        <Field as="select" name="class_id_encode" className="select-menu form-control">
                          <option value="">Select Class</option>
                         {
                            classList?.map((data, ind) => (
                              <option value={data.id} key={ind}>{data?.class_name}</option>
                            ))
                          }
                        </Field>
                        <ErrorMessage name="class_id_encode" component="div" className="text-danger" />
                      </div>

                      {/* <div className="col-md-6">
                          <label htmlFor="branch_id_encode" className="form-label">Branch Name(*)</label>
                          <Field as="select" name="branch_id_encode" className="select-menu form-control">
                            <option value="">Select Branch</option>
                            {
                              branchList?.map((data, ind) => (
                                <option value={data.id} key={ind}>{data?.name}</option>
                              ))
                            }
                       
                          </Field>
                          <ErrorMessage name="branch_id_encode" component="div" className="text-danger" />
                        </div> */}

                      <div className="col-md-6">
                        <label htmlFor="dob" className="form-label">DOB(*)</label>
                        <Field type="date" disabled className="form-control" style={{ paddingRight: '20px' }} id="dob" name="dob" />
                        <ErrorMessage name="dob" component="div" className="text-danger" />
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="gender" className="form-label">Gender(*)</label>
                        <Field as="select" disabled name="gender" className="select-menu form-control">
                          <option value="">Select Gender</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="Other">Other</option>
                        </Field>
                        <ErrorMessage name="gender" component="div" className="text-danger" />
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="blood_group" className="form-label">Blood Group</label>
                        <Field type="text" className="form-control" id="blood_group" name="blood_group" />
                        <ErrorMessage name="blood_group" component="div" className="text-danger" />
                      </div>


                      <div className="col-md-6">
                        <label htmlFor="education" className="form-label">Education</label>
                        <Field type="text" className="form-control" id="education" name="education" />
                        <ErrorMessage name="education" component="div" className="text-danger" />
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="education_dharmik" className="form-label">Education (Dharmik) </label>
                        <Field type="text" className="form-control" id="education_dharmik" name="education_dharmik" />
                        <ErrorMessage name="education_dharmik" component="div" className="text-danger" />
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="student_hobby" className="form-label">Student Hobby</label>
                        <Field type="text" className="form-control" id="student_hobby" name="student_hobby" />
                        <ErrorMessage name="student_hobby" component="div" className="text-danger" />
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="father_name" className="form-label">Father Name</label>
                        <Field type="text" className="form-control" id="father_name" name="father_name" />
                        <ErrorMessage name="father_name" component="div" className="text-danger" />
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="father_qualification" className="form-label">Father Qualification</label>
                        <Field type="text" className="form-control" id="father_qualification" name="father_qualification" />
                        <ErrorMessage name="father_qualification" component="div" className="text-danger" />
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="father_occupation" className="form-label">Father Occupation</label>
                        <Field type="text" className="form-control" id="father_occupation" name="father_occupation" />
                        <ErrorMessage name="father_occupation" component="div" className="text-danger" />
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="mother_name" className="form-label">Mother Name</label>
                        <Field type="text" className="form-control" id="mother_name" name="mother_name" />
                        <ErrorMessage name="mother_name" component="div" className="text-danger" />
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="mother_qualification" className="form-label">Mother Qualification</label>
                        <Field type="text" className="form-control" id="mother_qualification" name="mother_qualification" />
                        <ErrorMessage name="mother_qualification" component="div" className="text-danger" />
                      </div>

                      <div className="col-12">
                        <label htmlFor="address" className="form-label">Address(*)</label>
                        <Field as="textarea" disabled className="form-control" id="address" name="address" rows="5" />
                        <ErrorMessage name="address" component="div" className="text-danger" />
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="city" className="form-label">City(*)</label>
                        <Field type="text" disabled className="form-control" id="city" name="city" />
                        <ErrorMessage name="city" component="div" className="text-danger" />
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="email" className="form-label">Email(*)</label>
                        <Field type="email" disabled className="form-control" id="email" name="email" />
                        <ErrorMessage name="email" component="div" className="text-danger" />
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="whatsapp_no" className="form-label">Whatsapp No(*)</label>
                        <Field type="number" disabled className="form-control" id="whatsapp_no" name="whatsapp_no" />
                        <ErrorMessage name="whatsapp_no" component="div" className="text-danger" />
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="native_place" className="form-label">Native Place</label>
                        <Field type="text" className="form-control" id="native_place" name="native_place" />
                        <ErrorMessage name="native_place" component="div" className="text-danger" />
                      </div>

                      <div className="col-md-12">
                        <label htmlFor="declaration" className="form-label">Declaration</label>
                        <label className="declaration-box">
                          <Field type="checkbox" name="declaration" style={{ height: 24 }} className="mr-20 checkbox-declaration" />
                          <span>I declare that I have read and filled the above information, so if the information given by me is incorrect, you have the right to cancel without informing me.</span>
                        </label>
                        <ErrorMessage name="declaration" component="div" className="text-danger" />
                      </div>

                      <div className="col-12">
                        <div className="row">
                          <div className="d-flex justify-content-end">
                            <button type="submit" className="vs-btn wave-btn">Send Now</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
          {
            this.state.isModal && (
              <Modal isOpen={this.state.isModal} centered={true} toggle={() => this.setState({ isModal: false })}>
                <ModalBody className="py-3 px-5">
                  <Row>
                    <Col lg={12}>
                      <div className="text-center">
                        <i
                          className="mdi mdi-alert-circle-outline"
                          style={{ fontSize: "9em", color: "orange" }}
                        />
                        <FaCheckCircle
                          style={{
                            fontSize: "9em", color: "#22bb33"
                          }} />
                        <h3>For Registration</h3>
                        <h4>Please Select Payment Mode</h4>
                      </div>
                    </Col>
                    <Col lg={12} className="text-center">
                      <FormControl>

                        <RadioGroup
                          aria-labelledby="demo-controlled-radio-buttons-group"
                          name="controlled-radio-buttons-group"
                          value={this.state.paymentType}
                          onChange={(e) => this.setState({ paymentType: e.target.value })}
                        >
                          <Box className='d-flex'>
                            <FormControlLabel value="Offline" control={<Radio />} label="Offline" />
                            <FormControlLabel value="Online" control={<Radio />} label="Online" />
                          </Box>
                        </RadioGroup>
                      </FormControl>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="text-center mt-3">
                        <button
                          type="button"
                          className="btn btn-lg me-2"
                          style={{ background: "#22bb33", color: "#fff" }}
                          onClick={() => {
                            const updatedData = { ...this.state.userData, payment_type: this.state.paymentType }
                            this.createNewRegistration(updatedData)
                          }}
                        >
                          Submit
                        </button>
                        <button
                          type="button"
                          className="btn btn-danger btn-lg me-2"
                          onClick={() => this.setState({ isModal: false })}
                        >
                          Close
                        </button>
                      </div>
                    </Col>
                  </Row>
                </ModalBody>
              </Modal>
            )
          }
          {
            this.state.isAltId && (
              <Modal isOpen={this.state.isAltId} centered={true} toggle={() => this.setState({ isAltId: false })}>
                <ModalBody className="py-3 px-5">
                  <Row>
                    <Col lg={12}>
                      <div className="text-center">
                        <i
                          className="mdi mdi-alert-circle-outline"
                          style={{ fontSize: "9em", color: "red" }}
                        />
                        <IoMdCloseCircle
                          style={{
                            fontSize: "9em", color: "red"
                          }} />
                        <h3>For Old User Registration</h3>
                        <h4>Please Enter Correct Alternet Id</h4>
                      </div>
                    </Col>

                  </Row>
                  <Row>
                    <Col>
                      <div className="text-center mt-3">

                        <button
                          type="button"
                          className="btn btn-danger btn-lg me-2"
                          onClick={() => this.setState({ isAltId: false })}
                        >
                          Close
                        </button>
                      </div>
                    </Col>
                  </Row>
                </ModalBody>
              </Modal>
            )
          }
        </div>
      </section>
      <Footer />
    </React.Fragment>
  );
}
}

export default OldStudents;
